import p10_img from "./product_6.png";
import p11_img from "./product_6.png";
import p12_img from "./product_6.png";
import p13_img from "./product_13.png";
import p14_img from "./product_14.png";
import p15_img from "./product_15.png";
import p16_img from "./product_16.png";
import p17_img from "./product_17.png";
import p18_img from "./product_18.png";
import p19_img from "./product_19.png";
import p1_img from "./product_6.png";
import p20_img from "./product_20.png";
import p21_img from "./product_21.png";
import p22_img from "./product_22.png";
import p23_img from "./product_23.png";
import p24_img from "./product_24.png";
import p25_img from "./product_25.png";
import p26_img from "./product_26.png";
import p27_img from "./product_27.png";
import p28_img from "./product_28.png";
import p29_img from "./product_29.png";
import p2_img from "./product_6.png";
import p30_img from "./product_30.png";
import p31_img from "./product_31.png";
import p32_img from "./product_32.png";
import p33_img from "./product_33.png";
import p34_img from "./product_34.png";
import p35_img from "./product_35.png";
import p36_img from "./product_36.png";
import p3_img from "./product_6.png";
import p4_img from "./product_6.png";
import p5_img from "./product_6.png";
import p6_img from "./product_6.png";
import p7_img from "./product_6.png";
import p8_img from "./product_6.png";
import p9_img from "./product_6.png";

let all_product = [
  {
    id: 1,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
    number: 1,
  },
  {
    id: 2,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p2_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 2,
  },
  {
    id: 3,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p3_img,
    new_price: 60.0,
    old_price: 100.5,
    number: 3,
  },
  {
    id: 4,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p4_img,
    new_price: 100.0,
    old_price: 150.0,
    number: 4,
  },
  {
    id: 5,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p5_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 5,
  },
  {
    id: 6,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p6_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 6,
  },
  {
    id: 7,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p7_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 7,
  },
  {
    id: 8,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p8_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 8,
  },
  {
    id: 9,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p9_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 9,
  },
  {
    id: 10,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p10_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 10,
  },
  {
    id: 11,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p11_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 11,
  },
  {
    id: 12,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 12,
  }, {
    id: 13,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 13,
  }, {
    id: 14,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 14,
  }, {
    id: 15,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 15,
  }, {
    id: 16,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 16,
  }, {
    id: 17,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 17,
  }, {
    id: 18,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 18,
  }, {
    id: 19,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 19,
  }, {
    id: 20,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 20,
  }, {
    id: 21,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 21,
  }, {
    id: 22,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 22,
  }, {
    id: 23,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 23,
  }, {
    id: 24,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 24,
  },
  {
    id: 25,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p13_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 1,
  }, {
    id: 26,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p13_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 2,
  },
  {
    id: 27,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p14_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 3,
  }, {
    id: 28,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p14_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 4,
  },
  {
    id: 29,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p15_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 5,
  },
  {
    id: 30,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p15_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 6,
  },
  {
    id: 31,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p16_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 7,
  },
  {
    id: 32,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p16_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 8,
  },
  {
    id: 33,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p17_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 9,
  },
  {
    id: 34,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p17_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 10,
  },
  {
    id: 35,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p18_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 11,
  },
  {
    id: 36,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p18_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 12,
  },
  {
    id: 37,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p19_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 13,
  },
  {
    id: 38,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p19_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 14,
  },
  {
    id: 39,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p20_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 15,
  },
  {
    id: 40,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p20_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 16,
  },
  {
    id: 41,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p21_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 17,
  },
  {
    id: 42,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p21_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 18,
  },
  {
    id: 43,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p22_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 19,
  },
  {
    id: 44,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p22_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 20,
  },
  {
    id: 45,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p23_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 21,
  },
  {
    id: 46,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p23_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 22,
  },
  {
    id: 47,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p24_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 23,
  },
  {
    id: 48,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p24_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 24,
  },
  {
    id: 49,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p25_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 1,
  },
  {
    id: 50,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p25_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 2,
  },
  {
    id: 51,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p26_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 3,
  },
  {
    id: 52,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p26_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 4,
  },
  {
    id: 53,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p27_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 5,
  },
  {
    id: 54,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p27_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 6,
  },
  {
    id: 55,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p28_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 7,
  },
  {
    id: 56,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p28_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 8,
  },
  {
    id: 57,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p29_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 9,
  },
  {
    id: 58,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p29_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 10,
  },
  {
    id: 59,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p30_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 11,
  },
  {
    id: 60,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p30_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 12,
  },
  {
    id: 61,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p31_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 13,
  },
  {
    id: 62,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p31_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 14,
  },
  {
    id: 63,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p32_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 15,
  },
  {
    id: 64,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p32_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 16,
  },
  {
    id: 65,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p33_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 17,
  },
  {
    id: 66,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p33_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 18,
  },
  {
    id: 67,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p34_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 19,
  },
  {
    id: 68,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p34_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 20,
  },
  {
    id: 69,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p35_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 21,
  },
  {
    id: 70,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p35_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 22,
  },
  {
    id: 71,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p36_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 23,
  },
  {
    id: 72,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kids",
    image: p36_img,
    new_price: 85.0,
    old_price: 120.5,
    number: 24,
  },
];

export default all_product;
